import { Flex, Image } from "@chakra-ui/react";

const Loader = () => {
  return (
    <Flex alignItems="center" justifyContent="center">
      <Image
        width="150px"
        src="https://d1lfl311x81a6w.cloudfront.net/products/1730092605925.gif"
      />
    </Flex>
  );
};

export default Loader;
